var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 27.24 37.68" }, props),
    React.createElement("defs", null),
    React.createElement(
      "title",
      null,
      "block-icon-website"
    ),
    React.createElement(
      "g",
      { id: "Layer_2", "data-name": "Layer 2" },
      React.createElement("path", { className: styles["cls-1"] || "cls-1", d: "M0 0l3.54 33.5 7.29-6.18 6 10.37 7.41-4.28-6-10.41 9-3.22z", id: "Layer_1-2", "data-name": "Layer 1" })
    )
  );
});